export default __webpack_public_path__ + "static/media/Machining-Vendors.05918aeb.jpg";